import { BidPackagesPageView } from "src/routes/bids/BidPackagesPage";
import { useDevelopmentBidPackagesPageMetadataQuery } from "src/routes/developments/bid-packages/BidPackagesPage.generated";
import { queryResult } from "src/utils";

export function BidPackagesPage() {
  const query = useDevelopmentBidPackagesPageMetadataQuery();
  return queryResult(query, {
    data: ({ costCodes }) => <BidPackagesPageView costCodes={costCodes} />,
  });
}
